import $ from "jquery";

function ToggleMore() {
  //コンテンツの長さがmax-heightに満たない時「続きを見る」ボタンは非表示
  function showToggleButton(content) {
    var scrollHeight = content[0].scrollHeight,
      toggle = content.closest(".js-toggle-more"),
      button = toggle.find(".js-toggle-more-button");

    // SP時のイベント詳細のみ取得するmaxHeightの値変更
    var hasDetailPage = content.data("page") === "event-detail";
    var isSmallScreen = window.innerWidth <= 767;

    var maxHeight;
    if (hasDetailPage && isSmallScreen) {
      maxHeight = parseFloat(content.css("max-height"));
    } else {
      maxHeight = content.css("--max-height");
    }

    if (scrollHeight <= maxHeight) {
      button.hide();
      // aria属性
      $(this).attr("aria-expanded", true);
      content.attr("aria-hidden", false);
    } else {
      button.show().css("opacity", "1");
      // aria属性
      if (content.hasClass("is-open")) {
        content.attr("aria-hidden", false);
      } else {
        content.attr("aria-hidden", true);
      }
    }
  }

  //読み込み時
  $(".js-toggle-more-content").each(function () {
    var content = $(this);
    showToggleButton(content);
  });

  //トグルの中にある時の処理
  $(".js-toggle-trigger").on("click", function () {
    $(".js-toggle-more-content").each(function () {
      var content = $(this);
      showToggleButton(content);
    });
  });

  //「続きを見る」ボタンクリック時
  $(".js-toggle-more-button").on("click", function () {
    var toggle = $(this).closest(".js-toggle-more"),
      content = toggle.find(".js-toggle-more-content");
    $(this).toggleClass("is-open");
    content.toggleClass("is-open");
    if (content.hasClass("is-open")) {
      var h = content.get(0).scrollHeight;
      content.css("max-height", h);
      // aria属性
      $(this).attr("aria-expanded", true);
      content.attr("aria-hidden", false);
    } else {
      content.css("max-height", "");
      // aria属性
      $(this).attr("aria-expanded", false);
      content.attr("aria-hidden", true);
    }
  });

  //リサイズ時
  $(window).on("resize", function () {
    $(".js-toggle-more-content").each(function () {
      var content = $(this);

      //リサイズ完了後
      setTimeout(function () {
        var h = content.get(0).scrollHeight;

        if (content.hasClass("is-open")) {
          content.css("max-height", h);
        }

        showToggleButton(content);
      }, 300);
    });
  });
}

export { ToggleMore };
